module.exports = __webpack_public_path__ + "static/media/disabled-recurring.feb55536.svg";